import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ApiService } from '../api.service';
import { catchError, map } from 'rxjs/operators';
import { PlayerUrlAnnotationResponse } from './models/player-url-annotation/player-url-annotation.response';

@Injectable({
  providedIn: 'root',
})
export class PlayerUrlAnnotationService {
  constructor(
    private http: HttpClient,
    private apiService: ApiService,
  ) {}

  getPlayerUrlAnnotation(recordId: string, annotationSharedId: string): Observable<string> {
    const apiUrl = `${this.apiService.API_URL}/records/${recordId}/open`;
    return this.http.get<PlayerUrlAnnotationResponse>(apiUrl, { params: { annotationSharedId } }).pipe(
      map((url: PlayerUrlAnnotationResponse) => {
        return url.redirect;
      }),
      catchError((error: HttpErrorResponse) => {
        throw error;
      })
    );
  }
}
